import React from 'react';
import "./news.css"
import NewsPic from "../news-pic/pic1 (1).jpg"
import NewsPic2 from "../news-pic/pic1 (2).jpg"
import { useTranslation } from 'react-i18next'; // Add this import

const News6 = () => {
    const { t } = useTranslation(); // Add this hook

    return (
        <div>
            <br/>
            <br/>
            <br/>
            <div class="news">
                <article class="news-item">
                    <div class="news-item__date">
                        <svg class="news-item__date-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#718096" stroke-width="2">
                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                            <line x1="16" y1="2" x2="16" y2="6" />
                            <line x1="8" y1="2" x2="8" y2="6" />
                            <line x1="3" y1="10" x2="21" y2="10" />
                        </svg>
                        05.02.2024
                    </div>

                    <h2 class="news-item__title">
                        {t('news6.title')}
                    </h2>

                    <div class="news-item__content">
                        <p>{t('news6.content')}</p>
                    </div>
                    <div class="news-item__content">
                        <p>{t('news6.content2')}</p>
                    </div>

                    <div class="news-item__gallery">
                        <div class="news-item__image">
                            <img src={NewsPic} alt={t('news2.imageAlt')} />
                        </div>
                        <div class="news-item__image">
                            <img src={NewsPic2} alt={t('news2.imageAlt')} />
                        </div>
                    </div>
                    
                </article>
            </div>
        </div>
    );
}

export default News6;